import { useCallback, useEffect, useState } from "react";
import SnackbarUtils from "../../../../../libs/SnackbarUtils";

import { useParams } from "react-router-dom";
import {
  serviceGetPetProgram,
  servicetPetAssociate,
} from "../../../../../services/Pet.service";

const initialForm = {
  pet_ids: null,
};
const useAssociatePetHook = ({
  orderId,
  isOpen,
  handleToggle,
  updatePetList,
}) => {
  const [form, setForm] = useState(
    JSON.parse(JSON.stringify({ ...initialForm }))
  );
  const [errorData, setErrorData] = useState({});
  const [data, setData] = useState(null);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { id } = useParams();
  useEffect(() => {
    if (isOpen) {
      setForm({ ...initialForm });
      setIsSubmitted(false);
      setErrorData({});
    }
  }, [isOpen]);

  useEffect(() => {
    if (id) {
      serviceGetPetProgram({
        // index: 1,
        program_id: id,
      }).then((res) => {
        if (!res.error) {
          const resData = res?.data;
          setData(resData);
        }
      });
    }
  }, [id]);

  const checkFormValidation = useCallback(() => {
    const errors = { ...errorData };
    let required = [];
    required.forEach((val) => {
      if (!form?.[val]) {
        errors[val] = true;
      }
    });
    Object.keys(errors).forEach((key) => {
      if (!errors[key]) {
        delete errors[key];
      }
    });

    return errors;
  }, [data, form, errorData]);

  const submitToServer = useCallback(() => {
    if (!isSubmitting) {
      setIsSubmitting(true);
      const getPetId = data
        ?.filter((val) => val?.is_selected)
        ?.map((val) => val?.id);
      let req = servicetPetAssociate;
      if(!getPetId?.length){
        SnackbarUtils.error("Please select at least one Pet")
        setIsSubmitting(false);
        return
      }
      req({
        program_id: id,
        pet_ids: getPetId || [],
      }).then((res) => {
        if (!res.error) {
          SnackbarUtils?.success("Updated Successfully");
          handleToggle();
          updatePetList();
        }
        setIsSubmitting(false);
      });
    }
  }, [data, isSubmitting, setIsSubmitting, orderId, handleToggle]);

  const handleSubmit = useCallback(
    async (e) => {
      const errors = checkFormValidation();
      if (Object.keys(errors).length > 0) {
        setErrorData(errors);
        return true;
      }
      submitToServer();
    },
    [checkFormValidation, setErrorData, form, submitToServer]
  );

  const removeError = useCallback(
    (title) => {
      const temp = JSON.parse(JSON.stringify(errorData));
      temp[title] = false;
      setErrorData(temp);
    },
    [setErrorData, errorData]
  );

  const changeTextData = useCallback(
    (id) => {
      const updatedPets = data?.map((pet) => {
        if (pet?.id === id) {
          const updatedPet = { ...pet, is_selected: !pet.is_selected };
          return updatedPet;
        }
        return pet;
      });
      setData(updatedPets);
    },
    [removeError, data, setData]
  );

  const onBlurHandler = useCallback(
    (type) => {
      if (form?.[type]) {
        changeTextData(form?.[type].trim(), type);
      }
    },
    [changeTextData]
  );

  return {
    form,
    changeTextData,
    onBlurHandler,
    removeError,
    handleSubmit,
    errorData,
    isSubmitting,
    isSubmitted,
    data,
  };
};
export default useAssociatePetHook;
